<template>
  <div>
    <v-card flat :color="triageIcon.color" :class="spacingClass" :style="borderRadiusStyle">
      <v-card-title
          :dark="triageIcon.darkTheme"
          style="flex-direction: column"
      >
        <v-row justify="center" class="py-2">
          <v-icon size=40>{{ triageIcon.icon }}</v-icon>
        </v-row>
        <v-row justify="center" class="mb-2">
          <mrx-translation
              id="triage-header"
              class="px-2 font-weight-bold headline"
              :token="`triage.${triage}.title`"
          ></mrx-translation>
        </v-row>
        <v-row
            align="center"
            no-gutters
        >
          <v-col class="mb-0" style="text-align: center">
            <mrx-translation
                id="triage-banner"
                class="px-2 font-weight-bold"
                style="font-size: 16px"
                :token="`triage.${triage}.banner`"
            ></mrx-translation>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text class="pt-4" :class="bodyClass" style="font-size: 16px;">
        <mrx-translation
            id="triage-instructions"
            :token="`triage.${triage}.instructions`"
        ></mrx-translation>
        <template v-if="instructions">
          <div class="pt-2"></div>
          <v-divider class="py-1"></v-divider>
          <mrx-translation
              id="triage-selection-instructions"
              :token="`triage.selection_instructions.title`"
          ></mrx-translation>
        </template>
      </v-card-text>
    </v-card>
  </div>
</template>

<script lang="ts">
import './triage.css'
import { defineComponent } from 'vue'
import mrx from '@/mixins/mrx'
import icons from '@/mixins/icons'
import { mapState } from 'pinia'
import { useMrxStore } from '@/stores/mrx'

export default defineComponent({
  name: 'MedsincTriage',
  mixins: [mrx, icons],

  props: {
    borderRadius: {
      default: "16px",
      type: String
    },
    bodyClass: {
      default: "assessment-light panel-opaque",
      type: String
    },
    spacingClass: {
      default: "mb-4",
      type: String
    },
    instructions: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    triage(): string {
      if (this.selectedTriage() === 'none_selected') {
        return this.overallTriage
      }
      return this.selectedTriage()
    },
    triageIcon() {
      return this.icon(this.triage)
    },
    borderRadiusStyle() {
      return "border-radius: " + this.borderRadius.toString()
    },
    ...mapState(useMrxStore, {
      overallTriage: 'triage',
      selectedTriage: 'triageSelected',
    }),
  }
})
</script>